import { Inject, Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import moment from 'moment';

@Injectable({
    providedIn: 'root',
})
export class GatewayRequestsService {
    private _baseApiUrl: string = '';

    public constructor(
        private appService: AppService,
        public http: HttpClient,
        @Inject('API_BASE_URL') baseurl: string,
    ) {
        this._baseApiUrl = baseurl;
    }

    getGatewayRequestsReport = (
        creditorId: string,
        fromDate: Date,
        toDate: Date,
    ): Observable<any> => {
        let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);

        const apipath: string =
            'reports/PaymentGatewayCalls/creditor/' +
            creditorId +
            '?fromDate=' +
            moment(fromDate).format('YYYY-MM-DD') +
            '&toDate=' +
            moment(toDate).format('YYYY-MM-DD');
        const fullPath: string = this._baseApiUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();
        return this.http.get<any>(fullPath, options);
    };

    downloadGatewayRequestsReport = (
        creditorId: string,
        fromDate: Date,
        toDate: Date,
    ): Observable<Blob | null> => {
        let result: BehaviorSubject<Blob | null> =
            new BehaviorSubject<Blob | null>(null);
        const apipath: string =
            'reports/PaymentGatewayCalls/creditor/' +
            creditorId +
            '/download/' +
            '?fromDate=' +
            moment(fromDate).format('YYYY-MM-DD') +
            '&toDate=' +
            moment(toDate).format('YYYY-MM-DD');
        const fullPath: string = this._baseApiUrl + apipath;
        const options = {
            ...this.appService.getHttpHeaderOptions(),
            responseType: 'blob' as 'json',
        };

        this.http.get(fullPath, options).subscribe(
            (blob: any) => {
                result.next(blob);
                result.complete();
            },
            (error) => {
                result.next(error);
            },
        );
        return result;
    };
}
